export default __webpack_public_path__ + "static/media/inovallee.a254b3eb.jpg";